import { Route } from '@angular/router';

import { UserRouteAccessService } from '../shared';
import { CardDashboardTodayComponent } from './';

export const CARD_DASHBOARD_TODAY_ROUTE: Route = {
    path: 'card-dashboard-today',
    data: {
        authorities: ['ROLE_SCHOOL_ADMIN'],
        pageTitle: 'jYoguiApp.dashboard.title'
    },
    component: CardDashboardTodayComponent,
    canActivate: [ UserRouteAccessService ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/card-dashboard-today/card-dashboard-today.route.ts